import userActionTypes from '../../user/constants/action-types';
import injectBrandingColors from '../helpers/inject-branding-colors';

const colorsInjector = () => (next) => (action) => {
  const { type, payload } = action;

  switch (type) {
    case userActionTypes.SET_USER_PARTNER_DATA: {
      const { wsBranding } = payload.partnerData.properties;
      const colors = wsBranding && wsBranding.colors ? wsBranding.colors : {};

      injectBrandingColors(colors);

      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default colorsInjector;
